<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IIOX3X/tc-custom/9781467461122.jpg?1730409201039" alt="This image is the cover for the book 1–3 John, Two Horizons New Testament Commentary (THNTC)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">1–3 John, Two Horizons New Testament Commentary (THNTC)
      </h1>
      <p class="bookDescription body article font2">
        <p>The letters from John written to churches at the end of the first century CE possess meaningful theological insight for Christians today—in a sense, they were written <i>for us</i>. </p><p>Working from this standpoint, Thomas Andrew Bennett keeps historical speculation to a minimum and delves into the theological depths of 1–3 John in this commentary. He begins by providing a new translation of the text from the Greek, along with verse-by-verse exegesis, and then moves into an extended reflection on a litany of relevant theological topics, including questions of trinitarianism, creation, faith, atonement, eschatology, salvation, the nature of divine and human love, and the composition of the church. In these pages, readers challenged by Johannine metaphors (“walking in the light,” “children of God,” etc.) will find clarity, and pastors will find detailed guidance for teaching and preaching. </p><p>Bennett’s scholarship is critical but confessional, academic but accessible, and, above all, rooted in a faithful reverence that seeks not to read 1–3 John as a detached outsider to the text, but as the author’s fellow believer, so that the text’s theological concerns can be spoken to once again in a fresh and compelling way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Andrew Bennett
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Thomas Andrew Bennett</B>&#160;is affiliate assistant professor of theology at Fuller Theological Seminary and lead pastor of Coast Bible Church, San Juan Capistrano, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f522ca02